module.exports = __webpack_public_path__ + "static/media/ergo.08b2e49e.svg";


//////////////////
// WEBPACK FOOTER
// ./public/ergo.svg
// module id = 15
// module chunks = 0